import { useActive } from '@remirror/react';

interface ToolbarActiveResult {
  headingDisabled: boolean;
  listDisabled: boolean;
  formattingDisabled: boolean;
}

export function useToolbarActive(): ToolbarActiveResult {
  const active = useActive();

  const custom = is(active.image) || is(active.file);

  return {
    headingDisabled: custom || is(active.bulletList) || is(active.orderedList),
    listDisabled: custom || is(active.heading),
    formattingDisabled: custom,
  };
}

function is(arg: any) {
  if (typeof arg === 'function') {
    return arg();
  }
  return false;
}
